export default __webpack_public_path__ + "static/media/contactUsPhoto.9704c02e.png";